import { gql } from 'urql';
import { LocationDetails } from '../fragments/location.graphql';

export const getOrganizationBranches = gql`
  query GetOrganizationBranches($organizationId: Int, $owned: Boolean) {
    organization(organizationId: $organizationId) {
      id
      slug
      name
      branches(owned: $owned) {
        id
        region
        name
        shorthand
        district
        website
        branchOwners {
          id
          user {
            id
            fullName
            emailAddress
          }
        }
      }
    }
  }
`;

export const getBranch = gql`
  query GetBranch($branchId: Int!) {
    branch(branchId: $branchId) {
      id
      name
      region
      district
      registrationUrl
      shorthand
      website
      locations {
        ...LocationDetails
        existingEventsSize(branchId: $branchId)
      }
    }
  }
  ${LocationDetails}
`;

export const getBranchStaffs = gql`
  query GetBranchStaffs($branchId: Int!) {
    branch(branchId: $branchId) {
      id
      name
      branchAssistants {
        id
        assistantFlags
        user {
          id
          fullName
          recentEventAttendances {
            id
            event {
              id
              name
              startsAt
              branch {
                id
                shorthand
              }
            }
          }
        }
      }
      branchOwners {
        id
        user {
          id
          fullName
          recentEventAttendances {
            id
            event {
              id
              name
              startsAt
              branch {
                id
                shorthand
              }
            }
          }
        }
      }
    }
  }
`;

export const getActivePlayers = gql`
  query GetActivePlayers($branchId: Int!) {
    branch(branchId: $branchId) {
      id
      activePlayers {
        id
        role
        branch {
          id
          shorthand
        }
        user {
          id
          fullName
          recentEventAttendances {
            id
            event {
              id
              name
              startsAt
              branch {
                id
                shorthand
              }
            }
          }
        }
      }
    }
  }
`;

export const getEventsInLocation = gql`
  query GetEventsInLocation($branchId: Int!, $locationId: Int!) {
    branch(branchId: $branchId) {
      id
      location(locationId: $locationId) {
        id
        events(branchId: $branchId) {
          id
          name
          startsAt
          eventAttendeesSize
        }
      }
    }
  }
`;

export const getBranchCaps = gql`
  query GetBranchCaps($branchId: Int!) {
    branch(branchId: $branchId) {
      id
      caps {
        id
        user {
          id
          fullName
        }
        grantor {
          id
          fullName
        }
        amount
        state
        reason
        createdAt
      }
    }
  }
`;

export const getBranchCorrectiveActions = gql`
  query GetBranchCorrectiveActions($branchId: Int!) {
    branch(branchId: $branchId) {
      id
      correctiveActions {
        id
        kind
        reason
        startsAt
        endsAt
        createdAt
        user {
          id
          fullName
        }
        issuer {
          id
          fullName
        }
      }
    }
  }
`;

export const getBranchInvoice = gql`
  query GetBranchInvoice($branchId: Int!) {
    branch(branchId: $branchId) {
      id
      region
      name
      shorthand
      district
      invoice {
        billableAmount
        liveEventTicketCount
        virtualEventTicketCount
        additionalXpCount
        liveEventTicketBuybackCount
        virtualEventTicketBuybackCount
        additionalXpBuybackCount
        events {
          id
          name
          startsAt
          endsAt
          isCurrentCycle
          isCommunity
          isLegacy
          isVirtual
          fullCompensationTicketCount
          baseCompensationTicketCount
          ticketsSold
          extraXpSold
          billableAmount
          attendances {
            id
            kind
            paid
            attending
            buildGrowth
            baseCost
            extraXpCost
            totalCost
            user {
              id
              name
            }
            ticket {
              id
              label
              discountType
            }
            change {
              kind
              gameKind
              paid
              attending
              ticketLabel
              buildGrowth
            }
          }
        }
      }
    }
  }
`;
